import { pharmacyClient } from "@/connect";

export const getPurchaseReturns = async (
  page: number,
  pageSize: number,
  supplierId: string
) => {
  return await pharmacyClient.listPurchaseReturns({
    page: page,
    pageSize: pageSize,
    supplierId: supplierId === 'all' ? '' : supplierId
  });
};